import NyanFond from "./nyan/NyanFond";
import {REGLAGES as REGLAGES_NYAN} from "./nyan/reglages";
import MatrixFond from "./matrix/MatrixFond";
import {REGLAGES as REGLAGES_MATRIX} from "./matrix/reglages";
import ManettesFond from "./manettes/ManettesFond";
import {REGLAGES as REGLAGES_MANETTES} from "./manettes/reglages";
import VoyageurFond from "./voyageur/VoyageurFond";
import {REGLAGES as REGLAGES_VOYAGEUR} from "./voyageur/reglages";
import Veille95Fond from "./veille95/Veille95Fond";
import {REGLAGES as REGLAGES_VEILLE95} from "./veille95/reglages";
import DvdFond from "./dvd/DvdFond";
import {REGLAGES as REGLAGES_DVD} from "./dvd/reglages";
import XmbFond from "./xmb/XmbFond";
import {REGLAGES as REGLAGES_XMB} from "./xmb/reglages";
import OiseauFond from "./oiseau/OiseauFond";
import {REGLAGES as REGLAGES_OISEAU} from "./oiseau/reglages";

/**
 * Registre des fonds du bandeau d'Aerith.
 *
 * Pour ajouter un fond : suivre les consignes de README.md (dans ce dossier), puis ajouter UNE entrée ci-dessous.
 * Rien d'autre n'est à modifier : ni BandeauAerith, ni l'écran.
 *
 *   identifiant : minuscules, sans accent ni espace (c'est la valeur qui sera stockée et diffusée)
 *   nom         : libellé affiché dans le tableau de bord
 *   composant   : composant React du fond (voir les consignes)
 *   images      : (facultatif) libellé de la liste d'images de la galerie que le personnel peut associer à ce fond ; le
 *                 composant reçoit alors la propriété `images` (adresses). Sans cette entrée, le tableau de bord n'en propose pas.
 *   reglages    : (facultatif) description des réglages du fond (voir reglages.js, dans ce dossier, et le fichier reglages.js du
 *                 fond) : le tableau de bord en fabrique les curseurs et le composant reçoit la propriété `reglages`.
 */
export const FONDS = {
    nyan: {nom: "Nyan Cat", composant: NyanFond, reglages: REGLAGES_NYAN},
    matrix: {nom: "Matrix", composant: MatrixFond, reglages: REGLAGES_MATRIX},
    manettes: {nom: "Manettes", composant: ManettesFond, images: "Images de manettes", reglages: REGLAGES_MANETTES},
    voyageur: {nom: "Voyageur", composant: VoyageurFond, images: "Feuille du voyageur (PNG créé avec l'outil /outils-sprites.html ; la première est utilisée)", reglages: REGLAGES_VOYAGEUR},
    veille95: {nom: "Écrans de veille", composant: Veille95Fond, reglages: REGLAGES_VEILLE95},
    dvd: {nom: "Logo DVD", composant: DvdFond, images: "Logo qui rebondit (remplace le DVD ; la première image est utilisée)", reglages: REGLAGES_DVD},
    xmb: {nom: "Vague", composant: XmbFond, reglages: REGLAGES_XMB},
    oiseau: {nom: "Oiseau (façon Flappy Bird)", composant: OiseauFond, images: "Oiseau (remplace celui d'origine ; la première image est utilisée)", reglages: REGLAGES_OISEAU},
};

/** Fond affiché quand aucun n'est choisi, ou quand l'identifiant demandé n'existe pas (fond retiré, valeur erronée). */
export const FOND_PAR_DEFAUT = "nyan";

/** Identifiant utilisable : celui demandé s'il existe dans le registre, sinon le fond par défaut. */
export function fondOuDefaut(id) {
    return Object.prototype.hasOwnProperty.call(FONDS, id) ? id : FOND_PAR_DEFAUT;
}
